import { combineReducers } from 'redux';
import vcloud from './vcloud/vcloudReducer';

export default combineReducers({
	vcloud,
});
